<template>
    <div id="admin_page" class="container-fluid">
        <div class="row pull-right">
            <div class="col-12 margin-bottom5 text-right">
                <router-link :to="{ path: `/admin/indexes` }" class="btn btn-secondary main-button margin-right5">Indexing</router-link>
                <router-link v-if="getUserPermissions().view_campaign_groupings" :to="{ path: `/admin/campaign-groupings` }" class="btn btn-secondary main-button margin-right5">Campaign Groupings</router-link>
            </div>

            <div class="col-12 text-right">
                <router-link :to="{ path: `/admin/excluded-referrals` }" class="btn btn-secondary main-button margin-right5">Global Excluded Referrals</router-link>
                <router-link :to="{ path: `/admin/excluded-keywords` }" class="btn btn-secondary main-button margin-right5">Global Excluded Keywords</router-link>
                <router-link :to="{ path: `/admin/excluded-placements` }" class="btn btn-secondary main-button margin-right5">Global Excluded Placements</router-link>
                <router-link :to="{ path: `/admin/excluded-events` }" class="btn btn-secondary main-button margin-right5">Global Excluded Eventss</router-link>
                <router-link :to="{ path: `/admin/rules` }" class="btn btn-secondary main-button">Global Rules</router-link>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="actions" slot-scope="props" class="text-right">
                <router-link :to="{ path: `/admin/channel-groupings/client/${props.row.id}` }" class="btn btn-info reverse">Channel Groupings</router-link>
                <router-link :to="{ path: `/admin/excluded-keywords/client/${props.row.id}` }" class="btn btn-info reverse">Excluded Keywords</router-link>
                <router-link :to="{ path: `/admin/excluded-placements/client/${props.row.id}` }" class="btn btn-info reverse">Excluded Placements</router-link>
                <router-link :to="{ path: `/admin/excluded-events/client/${props.row.id}` }" class="btn btn-info reverse">Excluded Events</router-link>
                <router-link :to="{ path: `/admin/rules/client/${props.row.id}` }" class="btn btn-info reverse">Rules</router-link>
            </div>
        </v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                columns: ['name', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        name:    'Client Name',
                        actions: ''
                    },
                    sortable: ['name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} clients|{count} clients|One client',
                        filter: '',
                        filterPlaceholder: 'Search clients...',
                        noResults: 'No matching clients'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients')
                ])
                .then(axios.spread(clients => {
                    this.tableData = clients.data;
                }));
            }
        }
    }
</script>
